import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchByBlogType } from "../../../../services/blogsService";
import bikeBlogImg from "../../../assets/images/bike-blogs-img.jpg";
import './BlogsList.css';

export default function BlogsList() {
  const { blogType } = useParams(); // ✅ correct place
  const [blogs, setBlogs] = useState([]); // ✅ state

  const fetchBlogs = async () => {
    try {
      console.log("blogType:", blogType);

      const response = await fetchByBlogType(blogType);

      // adjust based on your API response shape
      setBlogs(response?.items || response || []);

      console.log("blogs:", response);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    if (blogType) {
      fetchBlogs(); // ✅ call API
    }
  }, [blogType]);

  return (
    <section className="blogs-list">
      <div className="blog-container">
        {blogs.length > 0 ? (
          blogs.map((blog, index) => (
            <div className="blog-item" key={blog.id || index}>
              <img
                src={blog.coverImageUrl || bikeBlogImg}
                alt={blog.title}
              />

              <div className="blog-content">
                <span className="blog-category">
                  {blog.blogType || "General"}
                </span>

                <h3>{blog.title}</h3>

                <p>
                  {blog.metaDescription ||
                    "Keep your bike running smoothly with these tips."}
                </p>

              <Link to={`/blogs/${blog.blogType}/${blog.seoSlug}`}>
                  <span className="read-more-bloglist">
                    Read More...
                  </span>
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p>No blogs found</p>
        )}
      </div>
    </section>
  );
}